module.exports = __webpack_public_path__ + "img/lvshihuijianshibanli.404e4aab.png";